import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import ClienteService from '../../../business-api/ClienteService'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    //CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem1,
    GridItem1xs2,
    GridItem2,
    GridItem2xs4,
    GridItem3,
    GridItem3xs4,
    GridItem4xs6,
    GridItem5,
    GridItem6,
    GridItem6xs12,
    GridItem8,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
    TextValidatorText,
    TextValidatorTextRequiredDestaque,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorCpf,
    TextValidatorCpfRequired,
    TextValidatorCep,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    AutocompletePadrao,
} from '../../../business-components/Autocomplete/Autocomplete'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    KeyboardDatePickerPadraoRequired,
    atribuiDataIdade,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    SexoRadioGroupRequired
} from '../../../business-rules/RadioGroup/SexoRadioGroup'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    ButtonVisualizarPDFTipoCarteiraInvestimento,
    ButtonGerarLinkClienteRight,
} from '../../../business-components/Button/Button'

import {
    IconButtonHelp,
    IconButtonEderecos,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
    CustomizedDialogsViewPDF,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import tipoOrigemClienteList from '../../../business-rules/List/tipoOrigemClienteList'

import tipoCarteiraInvestimentoList from '../../../business-rules/List/tipoCarteiraInvestimentoList'

import tipoArquivoList from '../../../business-rules/List/Arquivo/tipoArquivoList'

import momentoClienteList from '../../../business-rules/List/momentoClienteList'

import tipoRegimeBensList from '../../../business-rules/List/tipoRegimeBensList'

import tipoEstadoCivilList from '../../../business-rules/List/tipoEstadoCivilList'

import tipoIRList from '../../../business-rules/List/tipoIRList'

import profissaoList from '../../../business-rules/List/profissaoList'

import {
    getClienteRecomendouList,
    tituloCliente,
} from '../cliente-form/ClienteService'

import {
    getArquivoByGrupoArquivoTipoArquivoConteudo,
} from '../../arquivo/ArquivoService'

import {
    processaAlteracaoClienteTipoOrigemCliente,
    processaAlteracaoClienteProfissaoCliente,
    processaAlteracaoClientePossuiConjuge,
} from './CadastroServiceCliente'

import {
    familiarPossuiDespesaReceita
} from './CadastroServiceFamiliares'

import {
    obtemUfItcmdEnderecoResidencial,
} from '../estudo-form/EstudoServiceSucessaoVitalicia'

import {
    processaAlteracaoCepResidencial,
} from './CadastroServiceCliente'

import {
    AvatarClienteConjugeFamiliar
} from './CadastroCompClienteConjugeFamiliares'

import CadastroFormContato from './CadastroFormContato'

import CadastroFormContaInvestimentos from './CadastroFormContaInvestimentos'

import CadastroFormGerarLinkCliente from './CadastroFormGerarLinkCliente'

import CadastroFormEndereco from './CadastroFormEndereco'



export const CustomizedDialogsPopupGerarLinkCliente = ( {variaveisGlobais, values, handleChange, handleSubmit,
    setFieldValue, linhaTipoLicenca, jsonPagina, jsonUsuario, jsonUsuarioAdmin, linhaFormList} ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.buttonGerarLinkCliente}
            PopupButton={ButtonGerarLinkClienteRight}
            bgDefault={true}
            popupComponent={
                <CadastroFormGerarLinkCliente
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    linhaTipoLicenca={linhaTipoLicenca}
                    jsonPagina={jsonPagina}
                    jsonUsuario={jsonUsuario}
                    jsonUsuarioAdmin={jsonUsuarioAdmin}
                    linhaFormList={linhaFormList}
                />
            }
        />
    )
}

export const CardGridDivHeaderEntradaDadosCliente = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    vars, linhaFormList }) => {

    return (
        <CardGridDivHeaderEntradaDados>
            <CardGridDivEntradaDados>
                <GridContainer>
                    <GridItem6>
                        {tituloCliente(values)}
                    </GridItem6>

                    {vars.linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'N' && (
                        <GridItem6
                            className='mt--1 mb--4'
                        >
                            {values.id && values.nomeCliente && !values.jsonAcessoCliente.acessoCliente &&
                            vars.usuarioClienteSelecionadoAtivo === 'S' && (
                                <CustomizedDialogsPopupGerarLinkCliente
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    jsonPagina={vars.jsonPagina}
                                    jsonUsuario={vars.jsonUsuario}
                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    linhaFormList={linhaFormList}
                                />
                            )}
                        </GridItem6>
                    )}
                </GridContainer>
            </CardGridDivEntradaDados>
        </CardGridDivHeaderEntradaDados>
    )
}
export const NomeCliente = ({ values, handleChange, jsonConfiguracao, captacaoLeads }) => {

    return (
        <GridItem12>
            <TextValidatorTextRequiredDestaque
                name="nomeCliente"
                label={captacaoLeads ? LABEL.nomeCompleto : LABEL.nomeCliente}
                value={values.nomeCliente || ''}
                onChange={handleChange}
                tamMax={TAMMAX.nome}
                disabled={jsonConfiguracao && jsonConfiguracao.naoPermitirAlterarNomeCliente}
            />
        </GridItem12>
    )
}



export const NascimentoCliente = ({ values, setFieldValue, required }) => {

    const KeyboardDatePickerPadraoNascimentoCliente = required ? KeyboardDatePickerPadraoRequired : KeyboardDatePickerPadrao

    return (
        <GridItem4xs6>
            <MuiPickersUtilsProviderPadrao>
                <KeyboardDatePickerPadraoNascimentoCliente
                    name="nascimentoCliente"
                    label={LABEL.nascimento}
                    value={values.nascimentoCliente}
                    onChange={(date) => {
                        atribuiDataIdade(
                            setFieldValue,
                            date,
                            'nascimentoCliente',
                            'idadeCliente'
                        )}
                    }
                />
            </MuiPickersUtilsProviderPadrao>
        </GridItem4xs6>
    )
}



export const IdadeCliente = ({ values, handleChange }) => {

    return (
        <GridItem2>
            <TextValidatorNumberRequired
                name="idadeCliente"
                label={LABEL.idade}
                value={values.idadeCliente === 0 ? 0 : values.idadeCliente || ''}
                onChange={handleChange}
                numMin={NUMMIN.idadeNascimento}
                numMax={NUMMAX.idade}
                disabled={values.nascimentoCliente ? true : false}
            />
        </GridItem2>
    )
}

export const SexoCliente = ({ values, handleChange }) => {

    return (
        <SexoRadioGroupRequired
            name="sexoCliente"
            value={values.sexoCliente || ''}
            onChange={handleChange}
        />
    )
}

export const CepEnderecoCliente = ({ variaveisGlobais, values, handleChange, handleSubmit }) => {

    const ufItcmdEnderecoResidencial = obtemUfItcmdEnderecoResidencial(values)

    return (
        <>
            <GridItem2xs4>
                {(values.cepResidencial || !ufItcmdEnderecoResidencial) && (
                    <TextValidatorCep
                        name="cepResidencial"
                        label={LABEL.cepResidencial}
                        value={values.cepResidencial || ''}
                        onChange={handleChange}
                        onBlur={processaAlteracaoCepResidencial(variaveisGlobais, values)}
                    />
                )}
            </GridItem2xs4>

            <GridItem1xs2>
                <GridContainer>
                    <GridItem12>
                        <CustomizedDialogsPopup
                            maxWidth='md'
                            popupTitle={LABEL.enderecos}
                            tooltipTitle={LABEL.enderecos}
                            PopupButton={IconButtonEderecos}
                            bgDefault={true}
                            popupComponent={
                                <div
                                    className={'ml-4 mr-4'}
                                >
                                    <CadastroFormEndereco
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleChange={handleChange}
                                        handleSubmit={handleSubmit}
                                        popup={true}
                                    />
                                </div>
                            }
                        />
                    </GridItem12>

                    <GridItem12
                        align='center'
                    >
                        {ufItcmdEnderecoResidencial}
                    </GridItem12>
                </GridContainer>
            </GridItem1xs2>
        </>
    )
}

export const NomeCurtoCliente = ({ values, handleChange }) => {

    return (
        <GridItem6>
            <TextValidatorText
                name="nomeCurtoCliente"
                label={LABEL.nomeCurto}
                value={values.nomeCurtoCliente || ''}
                onChange={handleChange}
                tamMax={TAMMAX.nomeCurto}
            />
        </GridItem6>
    )
}

export const CpfCliente = ({ values, handleChange, jsonConfiguracao }) => {

    const TextValidatorCpfCliente =
        jsonConfiguracao && jsonConfiguracao.tornarCpfClienteObrigatorio
            ?
                TextValidatorCpfRequired
            :
                TextValidatorCpf

    return (
        <GridItem6>
            <TextValidatorCpfCliente
                name="cpfCliente"
                label={LABEL.cpf}
                value={values.cpfCliente || ''}
                onChange={handleChange}
                disabled={jsonConfiguracao && jsonConfiguracao.naoPermitirAlterarCpfCliente}
            />
        </GridItem6>
    )
}

export const RgCliente = ({ values, handleChange }) => {

    return (
        <GridItem6>
            <TextValidatorText
                name="rgCliente"
                label={LABEL.rg}
                value={values.rgCliente || ''}
                onChange={handleChange}
                tamMax={TAMMAX.rg}
            />
        </GridItem6>
    )
}

export const PossuiConjuge = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="possuiConjuge"
            label={LABEL.possuiConjuge}
            checked={values.possuiConjuge}
            onChange={handleChange}
            onBlur={processaAlteracaoClientePossuiConjuge(values)}
            disabled={
                (
                    values.nomeConjuge !== '' ||
                    familiarPossuiDespesaReceita(values, HARDCODE.idFamiliarConjuge) ||
                    familiarPossuiDespesaReceita(values, HARDCODE.idFamiliarCasal)
                ) && values.possuiConjuge
            }
        />
    )
}

export const TipoRegimeBens = ({ values, handleChange }) => {

    return (
        <>
            {values.possuiConjuge && (
                <>
                    <GridItem8>
                        <TextFieldTextSelect
                            name="tipoRegimeBens"
                            label={LABEL.tipoRegimeBens}
                            value={values.tipoRegimeBens || ''}
                            onChange={handleChange}
                            list={tipoRegimeBensList}
                        />
                    </GridItem8>
                    <GridItem1>
                        <IconButtonHelp
                            helpTitle={LABEL.tipoRegimeBens}
                            helpText={HELPTEXT.tipoRegimeBens}
                        />
                    </GridItem1>
                </>
            )}
        </>
    )
}

const PercMeacaoCliente = ({ values, handleChange }) => {

    return (
        <TextValidatorNumber
            name="percMeacaoCliente"
            label={LABEL.percMeacao + ' ' + tituloCliente(values)}
            value={values.percMeacaoCliente === 0 ? 0 : values.percMeacaoCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

const PercHerancaFamiliarDiferenteConjuge = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="percHerancaFamiliarDiferenteConjuge"
            label={LABEL.percHerancaFamiliarDiferenteConjuge}
            checked={values.percHerancaFamiliarDiferenteConjuge}
            onChange={handleChange}
        />
    )
}

export const Meacao = ({ values, handleChange }) => {
    
    const isXsDownScreen = IsXsDownScreen()

    return (
        <>
            {true && /*values.possuiConjuge && permitir informar sucessão para solteiros*/ (
                <>
                    {!isXsDownScreen && (
                        <GridItem3/>
                    )}
                    <GridItem3xs4>
                        <PercMeacaoCliente
                            values={values}
                            handleChange={handleChange}
                        /> 
                    </GridItem3xs4>

                    {values.possuiConjuge && values.percMeacaoCliente && (
                        <GridItem6xs12
                            className='mt-2'
                        >
                            <PercHerancaFamiliarDiferenteConjuge
                                values={values}
                                handleChange={handleChange}
                            /> 
                        </GridItem6xs12>
                    )}
                </>
            )}
        </>
    )
}

export const EstadoCivil = ({ values, handleChange }) => {

    return (
        <GridItem5>
            <TextFieldTextSelect
                name="estadoCivil"
                label={LABEL.estadoCivil}
                value={values.estadoCivil || ''}
                onChange={handleChange}
                list={tipoEstadoCivilList}
            />
        </GridItem5>
    )
}

export const TipoIRCliente = ({ values, handleChange }) => {

    return (
        <GridItem3>
            <TextFieldTextSelect
                name="tipoIRCliente"
                label={LABEL.tipoIR}
                value={values.tipoIRCliente || ''}
                onChange={handleChange}
                list={tipoIRList}
            />
        </GridItem3>
    )
}

export const IdClienteIntegracaoCRM = ({ values, handleChange }) => {

    return (
        <GridItem6>
            {values.idClienteIntegracaoCRM && (
                <TextValidatorText
                    name="idClienteIntegracaoCRM"
                    label={LABEL.idClienteIntegracaoCRM}
                    value={values.idClienteIntegracaoCRM || ''}
                    onChange={handleChange}
                    disabled={true}
                />
            )}
        </GridItem6>
    )
}



export const OrigemCliente = ({ variaveisGlobais, values, handleChange }) => {

    const [clienteRecomendouList, setClienteRecomendouList] = useState(null)

    useSingleton(async () => {

        setClienteRecomendouList(await getClienteRecomendouList(variaveisGlobais, values))
    })

    const linhaTipoOrigemClienteList = pesquisaList(tipoOrigemClienteList(null, false), values.tipoOrigemCliente)

    return (
        <GridContainer>
            <GridItem6>
                <TextFieldTextSelect
                    name="tipoOrigemCliente"
                    label={LABEL.tipoOrigemCliente}
                    value={values.tipoOrigemCliente || ''}
                    onChange={handleChange}
                    list={tipoOrigemClienteList(values.tipoOrigemCliente, false)}
                    onBlur={processaAlteracaoClienteTipoOrigemCliente(values)}
                />
            </GridItem6>
            
            <GridItem6
                style={{
                    display: 
                    linhaTipoOrigemClienteList.informaClienteRecomendou === "S"
                            ? "block"
                            : "none"
                }} 
            >
                {clienteRecomendouList
                    ?
                        <TextFieldTextSelect
                            name="clienteRecomendou"
                            label={LABEL.clienteRecomendou}
                            value={values.clienteRecomendou || ''}
                            onChange={handleChange}
                            list={clienteRecomendouList}
                            dontSort={true}
                        />
                    :
                        ''
                }
            </GridItem6>
            <GridItem6
                style={{
                    display: 
                        linhaTipoOrigemClienteList.informaTipoOrigemClienteOutras === "S"
                            ? "block"
                            : "none"
                }} 
            >
                <TextValidatorText
                    name="tipoOrigemClienteOutras"
                    label={
                        values.tipoOrigemCliente === HARDCODE.idTipoOrigemClienteIntegracaoMarketingDigital
                            ?
                                LABEL.tipoOrigemClienteMarketingDigital
                            :
                                LABEL.tipoOrigemClienteOutras
                    }
                    value={values.tipoOrigemClienteOutras || ''}
                    onChange={handleChange}
                    tamMax={TAMMAX.tipoOrigemClienteOutras}
                />
            </GridItem6>
        </GridContainer>
    )
}



export const TipoCarteiraInvestimentoCliente = ({ variaveisGlobais, values, handleChange, idConfiguracao }) => {

    const [pdf, setPdf] = useState(null)

    const obterPDFTipoCarteiraInvestimento = async ( tipoCarteiraInvestimentoCliente ) => {

        setPdf(null)

        if (tipoCarteiraInvestimentoCliente) {

            const tipoArquivo =
                pesquisaList(tipoCarteiraInvestimentoList, tipoCarteiraInvestimentoCliente).tipoArquivo

            const grupoArquivo =
                pesquisaList(tipoArquivoList, tipoArquivo).grupoArquivo

            const arquivoArquivoAcessoDTO = await getArquivoByGrupoArquivoTipoArquivoConteudo(variaveisGlobais,
                ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais), grupoArquivo, tipoArquivo, idConfiguracao, null, null)

            setPdf(arquivoArquivoAcessoDTO.conteudo)
        }
    }

    useSingleton(async () => {

        obterPDFTipoCarteiraInvestimento(values.tipoCarteiraInvestimentoCliente)
    })

    return (
        <>
            <GridItem6>
                <TextFieldTextSelect
                    name="tipoCarteiraInvestimentoCliente"
                    label={LABEL.tipoCarteiraInvestimentoCliente}
                    value={values.tipoCarteiraInvestimentoCliente || ''}
                    onChange={(e) => {
                        obterPDFTipoCarteiraInvestimento(e.target.value)
                        handleChange(e)
                    }}
                    list={tipoCarteiraInvestimentoList}
                />
            </GridItem6>
            
            {pdf
                ?
                    <GridItem6>
                        <CustomizedDialogsViewPDF
                            maxWidth='xl'
                            popupTitle={pesquisaDescricaoList(tipoCarteiraInvestimentoList,
                                values.tipoCarteiraInvestimentoCliente)
                            }
                            PopupButton={ButtonVisualizarPDFTipoCarteiraInvestimento}
                            pdfFile={pdf}
                        />
                    </GridItem6>
                :
                    ''
            }
        </>
    )
}



export const MomentoCliente = ({ values, handleChange }) => {

    return (
        !values.modoInteracaoCliente
            ?
                <GridItem6>
                    <TextFieldTextSelect
                        name="momentoCliente"
                        label={LABEL.momentoCliente}
                        value={values.momentoCliente || ''}
                        onChange={handleChange}
                        list={momentoClienteList}
                    />
                </GridItem6>
            :
                ''
    )
}

/*
export const ObservacaoCliente = ({ values, handleChange }) => {

    return (
        !values.modoInteracaoCliente
            ?
                <>
                    <CardGridDividerElementos/>

                    <GridContainer>
                        <GridItem12>
                            <TextValidatorText
                                name="observacaoCliente"
                                label={LABEL.observacaoCliente}
                                value={values.observacaoCliente || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.observacaoCliente}
                            />
                        </GridItem12>
                    </GridContainer>
                </>
            :
                ''
    )
}
    */


export const ProfissaoCliente = ({ values, handleChange }) => {

    return (
        <GridItem6>
            <AutocompletePadrao
                name="profissaoCliente"
                label={LABEL.profissao}
                value={values.profissaoCliente || ''}
                handleChange={handleChange}
                list={profissaoList}
                onBlur={processaAlteracaoClienteProfissaoCliente(values)}
            />
        </GridItem6>
    )
}



export const ProfissaoClienteOutras = ({ values, handleChange }) => {

    return (
        <GridItem6
            style={{
                display: 
                    values.profissaoCliente === HARDCODE.profissaoOutras ||
                    (values.profissaoCliente && values.profissaoCliente.indexOf(HARDCODE.profissaoOutrasFuncionarioPublico) !== -1)
                        ? "block"
                        : "none"
            }} 
        >
            <TextValidatorText
                name="profissaoClienteOutras"
                label={LABEL.profissaoOutras}
                value={values.profissaoClienteOutras || ''}
                onChange={handleChange}
                tamMax={TAMMAX.profissaoOutras}
            />
        </GridItem6>
    )
}



export const ContatoCliente = ({ values, handleChange, jsonConfiguracao }) => {

    return (
        <CadastroFormContato
            familiar={HARDCODE.idFamiliarCliente}
            values={values}
            handleChange={handleChange}
            jsonConfiguracao={jsonConfiguracao}
        />
    )
}



export const ContaInvestimentosCliente = ({ values, handleChange }) => {

    return (
        <CadastroFormContaInvestimentos
            familiar={HARDCODE.idFamiliarCliente}
            values={values}
            handleChange={handleChange}
        />
    )
}



export const AvatarCliente = ({ values, setFieldValue }) => {

    return (
        <AvatarClienteConjugeFamiliar
            name='avatarCliente'
            value={values.avatarCliente}
            setFieldValue={setFieldValue}
            sexo={values.sexoCliente}
        /> 
    )
}